<template>
    <div class="hidden md:block">
        <div class="border-gray-325 bg-white shadow">
            <div class="mb-2 p-4 text-[16px] font-semibold text-gray-900">
                Quizzes <span class="text-gray-625"> (by focus area)</span>
            </div>
            <table class="w-full">
                <thead
                    class="text-left text-[14px] font-semibold text-gray-625"
                >
                    <th class="p-2 pl-4">Focus Area</th>
                    <th class="w-16 p-2">Results</th>
                    <th class="p-2">
                        Score
                        <span class="font-normal"> (last 100 questions) </span>
                    </th>
                    <th class="p-2"></th>
                </thead>
                <tbody>
                    <template
                        v-for="focusArea in studentFocusAreasWithPerformance"
                    >
                        <tr class="border-t border-gray-325 odd:bg-gray-50">
                            <td class="p-2 pl-4 text-[16px] font-semibold">
                                <text-clamp
                                    autoResize
                                    :max-lines="1"
                                    :text="getFocusArea(focusArea.fa_id).title"
                                >
                                </text-clamp>
                            </td>
                            <td
                                class="p-2 text-center text-[16px]"
                                title="Average score (Last 100 questions)"
                            >
                                <StudentScoreBox
                                    :percent-average="focusArea.avg"
                                />
                            </td>
                            <td
                                class="p-2 text-[15px] font-medium text-gray-625"
                            >
                                {{ focusArea.q_total - focusArea.q_missed }}/{{
                                    focusArea.q_total
                                }}
                                correct
                            </td>
                            <td class="p-2 text-right text-[15px]">
                                <Link
                                    :href="
                                        route('student.focus-area.index', {
                                            focus_area: focusArea.fa_id,
                                        })
                                    "
                                    class="text-primary-525"
                                    >Study
                                    <span class="hidden lg:inline-block"
                                        >Materials</span
                                    >
                                </Link>
                                <student-take-quiz-button
                                    quiz-type="focus_area"
                                    :focus-area="getFocusArea(focusArea.fa_id)"
                                    button-css="ml-4 inline-block rounded bg-primary-525 px-2 py-2 text-[15px] text-white hover:cursor-pointer hover:bg-primary-600"
                                />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
    <div class="md:hidden">
        <template v-for="focusArea in studentFocusAreasWithPerformance">
            <div class="mb-4 border-y border-gray-325 bg-white p-3">
                <div class="mb-4 flex justify-between gap-4">
                    <div class="">
                        <div
                            class="text-[17px] font-semibold tracking-tight text-gray-800"
                        >
                            <text-clamp
                                autoResize
                                :max-lines="1"
                                :text="getFocusArea(focusArea.fa_id).title"
                            >
                            </text-clamp>
                        </div>
                        <div class="text-gray-625">
                            {{ focusArea.q_total - focusArea.q_missed }}/{{
                                focusArea.q_total
                            }}
                            correct
                        </div>
                    </div>
                    <div class="ml-auto w-16 flex-none text-center">
                        <StudentScoreBox :percent-average="focusArea.avg" />
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <student-take-quiz-button
                        quiz-type="focus_area"
                        :focus-area="getFocusArea(focusArea.fa_id)"
                        button-css="w-full rounded bg-primary-525 p-2 text-center text-[16px] font-medium text-white hover:cursor-pointer hover:bg-primary-600"
                    />
                    <Link
                        :href="
                            route('student.focus-area.index', {
                                focus_area: focusArea.fa_id,
                            })
                        "
                        as="div"
                        class="w-full rounded border border-gray-325 p-2 text-center text-[16px] font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-325"
                    >
                        Study Materials
                    </Link>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import StudentScoreBox from "@/Components/StudentScoreBox.vue";
import StudentTakeQuizButton from "@/Components/StudentTakeQuizButton.vue";

export default {
    name: "StudentQuizzesByFocusAreaTable",
    components: { StudentTakeQuizButton, StudentScoreBox },
    props: {
        studentFocusAreasWithPerformance: {
            type: Object,
            default: {},
        },
    },
    methods: {
        getFocusArea(focusAreaId) {
            let focusArea = _.find(
                this.$page.props.focusAreas,
                function (focusArea) {
                    return focusArea.id === focusAreaId;
                }
            );

            return focusArea;
        },
    },
};
</script>
